module.exports = __webpack_public_path__ + "static/media/light_fixture_galeon_L.c5a04417.jpg";